import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { APP_SERVICES_NAME } from "../storageObjectSlice/constants";
import { TUiApp, TUiService, UiState } from "./types";
import { getUiInitialState } from "./utils/getUiInitialState";
import { APP_UI_STATE } from "./constants";
import { StorageScope } from "../../../services/api/instances/storageApi/types/service_types";

const initialState: UiState = {
  ui: getUiInitialState(APP_SERVICES_NAME),
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setUi: (state, action: PayloadAction<TUiApp>) => {
      state.ui = action.payload;
      localStorage.setItem(APP_UI_STATE, JSON.stringify(action.payload));
    },
    setServiceUi: (
      state,
      action: PayloadAction<{ service: StorageScope; ui: TUiService }>,
    ) => {
      const { service, ui } = action.payload;
      if (!state.ui) return;
      state.ui[service] = ui;
      localStorage.setItem(APP_UI_STATE, JSON.stringify(state.ui));
    },
  },
});

export const uiReducers = uiSlice.reducer;

export const { setUi, setServiceUi } = uiSlice.actions;
